const screens = require("./OnboardingScreens").default;

export default [
  {
    title: "Hi! I'm Mari, the\n Spirit of Time!",
    subTitle: "Have we met before?",
    subTitleCss: "subTitle1",
    animation: screens[0],
  },
  {
    title: "It's a pleasure\n to meet you!",
    animation: screens[1],
  },
  {
    title: "This is Mana",
    subTitle: "Mana is Time",
    animation: screens[2],
  },
  {
    title: "This Mana is\n beautiful!",
    subTitle: "I love time\n that's spent well!",
    animation: screens[3],
  },
  {
    title: "It was spent\n intentionally,",
    subTitle: "reflected on,\n and made\n people happy",
    animation: screens[4],
  },
  {
    title: "I don't know\n about this Mana",
    subTitle: "Like most time,\n nobody knows if it\n was spent well or not",
    animation: screens[5],
  },
  {
    title: "It's easy to let\n time slip away...",
    titleCss: "top50",
    animationContainerCss: "imageContentBottom",
    animationCss: "moveY70",
    animation: screens[6],
  },
  {
    subTitle: "...and wonder\n why life\n doesn't meet\n expectations",
    subTitleCss: "textBottomRight",
    animationContainerCss: "imageContentBottom",
    animationCss: "imageBottom",
    animation: screens[7],
  },
  {
    title: "I help you\n understand\n your time,",
    titleCss: "textTopLeft",
    subTitle: "and plot a\n path to\n fulfillment",
    subTitleCss: "textBottomCenter",
    animationContainerCss: "imageContentBottom",
    animationCss: "imageBottom",
    animation: screens[8],
  },
  /* {
    title: "Time empowers the\n essentials of your life",
    animationCss: "imageFullscreen",
    animation: screens[9],
  }, */
  {
    title: "I make\n tracking easy,",
    subTitle: "especially with\n integrations!",
    animationContainerCss: "imageContentEnd",
    animationCss: "image95",
    animation: screens[10],
  }, 
  {
    title: "Become\n Mindful of Time",
    subTitle: "Let’s treasure your\n Mana, together",
    animationCss: "imageMindful",
    animation: screens[11],
  },
];
